import {Injectable} from '@angular/core';
import {BaseService} from "./common/base.service";
import {FilterService} from "./filterer/filter.service";
import {DataManipulationService} from "./common/data-manipulation.service";
import {ValidatorService} from "./common/validator.service";
import {Dtos} from "../utils/dtos";
import {MbColDefinition, MbColInput} from "../components/mb-datatable/models/mb-datatable.model";
import {PlaceRepository} from "../repositories/place.repository";
import {BasePlace} from "./restaurant.service";
import {MbDatatablesTemplate} from "../components/mb-datatable/mb-datatables-template";

@Injectable({
    providedIn: 'root'
})
export class PlaceService extends BaseService<PlaceRepository> {

    constructor(repo: PlaceRepository, filterService: FilterService, dataManipulationService: DataManipulationService, validatorService: ValidatorService) {
        super(repo, filterService, dataManipulationService, validatorService);
        this.typeName = 'Place';
    }

    public getAll() {
        return super.getAll(Dtos.RESTAURANT.PlaceDTO);
    }

    public attachPlaceToRestaurantHistory(restaurantHistoryId: number, placeId: any) {
        return this.repo.attachPlaceToRestaurantHistory(restaurantHistoryId, placeId);
    }

    public getAllPlaceForRestaurantHistory(restaurantHistoryId: number) {
        return this.repo.getAllPlaceForRestaurantHistory(restaurantHistoryId);
    }

    protected defineModelSpecificColumns(extraInfo?: any): any[] {
        return [
            MbColDefinition.new('name', 'restaurant.place.name'),
            MbColDefinition.new('maxCapacity', 'restaurant.place.maxCapacity'),
            MbColDefinition.new('saturation', 'restaurant.place.saturation'),
            MbColDefinition.new('available', 'restaurant.place.available', MbColInput.new(MbColInput.SELECT, [
                {label: 'general.true', value: 'true'},
                {label: 'general.false', value: 'false'}
            ]), MbDatatablesTemplate.TRANSLATE_TEMPLATE),
        ];
    }

    validate(place: BasePlace) {
        if (place.maxCapacity != (place.pufferCapacity + place.cookingCapacity)) {
            throw new Error("error.place.invalidCapacityValues");
        }
        if (place.maxCapacity < 1 || (place.pufferCapacity + place.cookingCapacity) < 1) {
            throw new Error("error.place.invalidCapacityValues");
        }
        if (place.name == null || place.name.length < 1) {
            throw new Error("error.place.invalidName");
        }
        if (place.saturation < 1 || place.saturation > 100) {
            throw new Error("error.place.invalidSaturation");
        }
    }

}

